import { DefaultTheme } from "styled-components";

export const lightTheme: DefaultTheme = {
  text: "#363537",
  background: "#FAFAFA",
  highlight: "#fcf4a3",
  mode: "light",
  tableBorder: "#36353750",
};

export const darkTheme: DefaultTheme = {
  text: "#FAFAFA",
  background: "#363537",
  highlight: "#da1af3",
  mode: "dark",
  tableBorder: "#FAFAFA50",
};
